import translate from "../locales";

export function StartPage({ onStart, statementCount }) {
  return (
    <main className="content">
      <h1 className="content__title">{translate("start.title")}</h1>
      <p className="content__subtitle">
        {translate("start.subtitle", { count: statementCount })}
      </p>

      <button
        className="content__button button button--uppercase"
        onClick={onStart}
      >
        {translate("start.button")}
      </button>

      <p className="content__disclaimer">{translate("general.disclaimer")}</p>
    </main>
  );
}
